import { getDataWithPromise, Globals, handleAjaxError } from "./BaseDataFns";
import {ChildRoles} from "root/DataFunctions/Constants";

export const getChildDetails = (child_id, onCompleteFunc) => {

  if (child_id == null)
  {
    throw new Error('Invalid Child ID passed to getChildDetails')
  }
  else
  {
    const url = Globals.APIFolder + '/child/' + child_id;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
      onCompleteFunc(data);
    })
    .catch((jqXHR, textStatus, error) =>
    {
      handleAjaxError(jqXHR, textStatus, error);
    });
  }
};

/*export const getChildConnections = (child_id, onCompleteFunc) => {

  const url = Globals.APIFolder + '/child/' + child_id + '/connections' ;

  getDataWithPromise(url, 'GET', {}).then(data =>
  {
    onCompleteFunc ( data );
  })
  .catch((jqXHR, textStatus, error) =>
  {
    handleAjaxError(jqXHR, textStatus, error);
  });

  return ;
};*/

export const getMyChildren = (status, onCompleteFunc) => {

  const url = Globals.APIFolder + '/users/current/children?connection_type=all&status='+status;

  getDataWithPromise(url, 'GET', {}).then(data =>
  {
    onCompleteFunc(data);
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });
}

export const getChildForUser = (child_uid, user_id, onCompleteFunc) => {

  const url = Globals.APIFolder + '/users/' + user_id + '/children/' + child_uid;

  getDataWithPromise(url, 'GET', {}).then(data =>
  {
    onCompleteFunc(data);
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });
}

export const saveNewChild = (formData, onCompleteFunc) => {

  const url = Globals.APIFolder + '/child';

  getDataWithPromise(url, 'POST', { formData: formData }).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });
};

export const updateChildDetails = ( child_id, postFormData, onCompleteFunc) => {

  const url = Globals.APIFolder  + '/child/' + child_id;

  getDataWithPromise(url, 'PUT', {formData: postFormData}).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });
};

/* Siblings form not used  - steve 25/05/23
///////////////
// Siblings
///////////////

export const getSiblingDetails = (ur_id, onCompleteFunc) => {

  const url = Globals.APIFolder + '/child/sibling/' + ur_id;

  getDataWithPromise(url, 'GET', {}).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });

  return ;
};

export const getSiblings = (child_id, approved_only, onCompleteFunc) => {

  const url = Globals.APIFolder + '/users/' + child_id + '/contacts?user_role=' + ChildRoles.CONTRIBUTOR+'&direction=send';

  getDataWithPromise(url, 'GET', {}).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });

  return ;
};

export const saveNewSibling = (child_id, formData, onCompleteFunc) => {

  const url = Globals.APIFolder + '/child/' + child_id + '/sibling';

  getDataWithPromise(url, 'POST', formData).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });

  onCompleteFunc();

  return;
};

export const updateSibling = ( ur_id, formData, onCompleteFunc) => {

  const url = Globals.APIFolder + '/child/sibling/' + ur_id;

  getDataWithPromise(url, 'PUT', formData).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });

  onCompleteFunc();

  return;
};

export const deleteSibling = ( ur_id, onCompleteFunc) => {

  const url = Globals.APIFolder + '/child/sibling/' + ur_id;

  getDataWithPromise(url, 'DELETE', {}).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });

  onCompleteFunc();

  return;
};*/

////////////////

export const getChildImageUrl = (document_id, child_uid) => {

  var url = '';

  if(document_id === null || document_id === undefined){
    url = '/images/defaultPerson.jpg'
  }
  else{
    url = Globals.APIFolder + '/child/' + child_uid + '/document/' + document_id + '?size=100&square=false';
  }

  return url;
};

export const getOpenImageUrl = (document_id, child_uid) => {

  var url = '';
  url = Globals.APIFolder + '/child/' + child_uid + '/document/' + document_id + '?size=400&square=false';

  return url;
};


export const getChildResources = (type_id, onCompleteFunc) => {

  const url = Globals.APIFolder + "/child/me/resources?approved=true";

  getDataWithPromise(url, 'get', { "type_id": type_id }).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });

  return ;
};

export const getMessagesForChild = (status, onCompleteFunc) => {

  const url = Globals.APIFolder + "/user/current/messages?message_status=" + status;
  
  getDataWithPromise(url, 'get', {}).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });

  return ;
};

/*export const moveChildMessageToDraft = (post_id, postVars, onCompleteFunc) => {

  const url = Globals.APIFolder + "/message/" + post_id + "/status";
  
  getDataWithPromise(url, 'put', {...postVars}).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });

  return ;
};*/

//Gets a child's current theme
export const getMyTheme = (onCompleteFunc) => {

  const url = Globals.APIFolder + "/child/current/theme";

  getDataWithPromise(url, 'get', {}).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });

  return ;
};

//Updates a child's current theme
export const updateMyTheme = (theme_id, onCompleteFunc) => {

  const url = Globals.APIFolder + "/child/current/theme";

  getDataWithPromise(url, 'post', { "theme_id": theme_id }).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });

  return ;
};

export const getChildThemes = (onCompleteFunc) => {

  const url = Globals.APIFolder + '/themes';

  getDataWithPromise(url, 'get', {}).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });

  return ;
};

//Gets all child post
export const getMyPosts = (onCompleteFunc) => {

  const url = Globals.APIFolder + '/child/me/posts?filter=child_homepage';

  getDataWithPromise(url, 'get', {}).then(data =>
  {
      onCompleteFunc ( data );
  })
    .catch((jqXHR, textStatus, error) =>
    {
        handleAjaxError(jqXHR, textStatus, error);
    });

  return ;
};

//Gets all child post by year filter
export const getPostsByYear = (year, gallery=false, onCompleteFunc) => {

  let url = Globals.APIFolder + '/child/me/posts';

  if ( year != null ) {
      url = url + '?year=' + year + '&gallery=' + gallery ;
  }
  else{
    url = url + '?gallery=' + gallery;
  }

  getDataWithPromise(url, 'get', {}).then(data =>
  {
      onCompleteFunc ( data );
  })
    .catch((jqXHR, textStatus, error) =>
    {
        handleAjaxError(jqXHR, textStatus, error);
    });

  return ;
};

export const getChildDiaryEntries = (onCompleteFunc) => {

  const url = Globals.APIFolder + "/child/me/diary/all";
  
  getDataWithPromise(url, 'get', {}).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });

  return ;
};

export const createChildDiaryEntry = (entry, onCompleteFunc) => {

  const url = Globals.APIFolder + "/child/current/diaryEntry";

  getDataWithPromise(url, 'post', {...entry}).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });

  return ;
};

//gets child's primary contact details (the first editor record
export const getChildPrimaryContact = (onCompleteFunc) => {

  const url = Globals.APIFolder + '/child/primaryContact';

  getDataWithPromise(url, 'get', {}).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });

  return ;
};

//Get's child's family tree
export const getMyFamilyTree = (onCompleteFunc) => {

  const url = Globals.APIFolder + '/child/current/familyTree';

  getDataWithPromise(url, 'GET', {}).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });
}

//Counts the number of child's editors in their connections
export const countNumberOfEditors = (childConnections) =>
{
  const n = childConnections.length;
  let count = 0;

  for(let i =0; i < n; i++){
    if(childConnections[i].editor !== undefined){
      count = count + 1;
    }
  }

  return count;
}






